'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const BgColors = [
  "zapier",
  "night",
  "moss",
  "neutral800",
  "neutral100",
  "earth"
];
const BgColorMap = {
  lava60: "zapier",
  ocean40: "night",
  sun60: "moss",
  white: "neutral100"
};
const TextColorMap = {
  zapier: "cream",
  neutral100: "neutral800",
  night: "neutral100",
  moss: "neutral100",
  neutral800: "neutral100",
  earth: "neutral100"
};

exports.BgColorMap = BgColorMap;
exports.BgColors = BgColors;
exports.TextColorMap = TextColorMap;
//# sourceMappingURL=constants.cjs.js.map
